<template>
    <div class="light-color-bg position-relative">
        <QuestionTitle number="02" :question="question" :comment="comment" :modalActivator="modalActivator" @activateModal="modalActive=true"></QuestionTitle>
        <div class="container-70">
            <AccordeonBox :headerText="headerText" :bodyText="bodyText"></AccordeonBox>
            <div v-if="result!=null" @click="saveAndContinue('citoyenTransport', JSON.stringify(result), './question-3')" class="btn-primary d-block w-100 mt-50px text-center" >Suivant</div>
            <AvancementLine percent="33%" class="mt-50px"></AvancementLine>
            <ModalInfo @closeModal="modalActive=false" v-if="modalActive">
                <h3 class="modal-title">GES émis par vos transports</h3>
                <p class="modal-text">Au Québec, c'est le secteur des transports qui émet le plus de GES et donc, contribue le plus aux changements climatiques. Cette section permet d'estimer les GES émis par vos transports. Elle est divisée en deux catégories, soit vos déplacements quotidiens ou réguliers et ceux réalisés dans un contexte de voyage.</p>
            </ModalInfo>
        </div>
    </div>
</template>
<script>
import QuestionTitle from '@/components/QuestionTitle.vue'
import AvancementLine from '@/components/AvancementLine.vue'
import AccordeonBox from '@/components/AccordeonBox.vue'
import ModalInfo from '@/components/ModalInfo.vue'
/*Mixins*/
import utils from '@/mixins/utils'
export default {
    data() {
        return {
            result:null,
            modalActive:false,
            question:'Indiquez les distances parcourues pour les transports réguliers de votre ménage au cours d\'une année.',
            comment:'Ils incluent, par exemple, les trajets pour se rendre au travail ou à l\'école, pour faire les commissions, les sorties, visiter la famille, etc. Les voyages seront compilés au tableau suivant.',
            modalActivator:true,
            headerText:'Besoin d’aide pour votre calcul?',
            bodyText: 'Pour faire ce calcul, utilisez une application comme Google Maps pour tracer les principaux itinéraires que vous faites dans une semaine. Ensuite, multipliez le nombre de kilomètres par la fréquence que vous les faites dans l\'année.<br/>Ex : Le trajet maison/école/travail se fait 2 fois par jour, multipliez par 5 jours pour le nombre de kilomètres par semaine. Ensuite, multipliez par 50 semaines (si vous avez deux semaines de vacances par année) pour avoir le total de ce trajet sur l\'année.<br/>Ex 2 : Vous allez visiter vos parents à l\'extérieur en moyenne une fois par mois. Calculez le trajet aller-retour et multipliez le par le nombre de fois que vous le réalisez dans l\'année.<br/>Pour compléter le calcul, additionnez le total des différents trajets, ajoutez au besoin un peu de kilométrages supplémentaires pour les sorties ponctuelles, et cela devrait vous donner un total représentatif pour l\'année.'
        }
    },
    components: {
        QuestionTitle,
        AvancementLine,
        AccordeonBox,
        ModalInfo
    },
    mixins:[utils],
    mounted(){
        if(sessionStorage.getItem('citoyenTransport')){
            this.result=JSON.parse(sessionStorage.getItem('citoyenTransport'))
        }
    }
}
</script>